<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">OTHER TITLES BY CJ LYONS</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Lucy Guardino FBI Thrillers:</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Snake Skin</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Blood Stained</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Kill Zone</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>After Shock</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Hard Fall</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Last Light</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Devil Smoke</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Gone Dark</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Bitter Truth</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Lesser Evil</i></p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Renegade Justice Thrillers, featuring Morgan Ames</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Fight Dirty</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Raw Edges</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Angels Weep</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Look Away</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Trip Wire</i></p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Caitlyn Tierney FBI Thrillers:</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Blind Faith</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Black Sheep</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Hollow Bones</i></p>
</div>
<p class="implicit-break basic-break"></p>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Hart and Drake Thrillers:</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Nerves of Steel</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Sleight of Hand</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Face to Face</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Eye of the Storm</i></p>
</div>
</div>
<p class="implicit-break basic-break"></p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Shadow Ops Thrillers:</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Chasing Shadows</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Lost in Shadows</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Edge of Shadows</i></p>
</div>
</div>
<p class="implicit-break basic-break"></p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Angels of Mercy Novels:</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Lifelines</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Warning Signs</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Urgent Care</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Critical Condition</i></p>
</div>
</div>
<p class="implicit-break basic-break"></p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">AJ Palladino Novels (cowritten with Erin Brockovich):</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Rock Bottom</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Hot Water</i></p>
</div>
</div>
<p class="implicit-break basic-break"></p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Other Thrillers:</p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Borrowed Time</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Lucidity</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Farewell to Dreams</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// other-titles-by-cj-lyons.vue?041327da